export default [
  {
    "user": {
      "name": "gh1",
      "vmnr": "99998"
    },
    "step1locked": true,
    "submitTime": "6.9.2018, 10:40:57",
    "civilServant": true,
    "categories": ["P", "V", "B", "W"],
    "family": "MPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Familie",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "EXP-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": true,
    "ssrdisabled": false,
    "ssrsb": "SB300",
    "cyberselected": true,
    "cyberdisabled": false,
    "cybersb": "SB150",
    "zwselected": true,
    "zwdisabled": false,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "Hallesches Ufer",
      "hausnummer": "83",
      "ort": "Perl",
      "plz": "66706",
      "bruttojahresmiete": "",
      "land": "Deutschland",
      "sb": "",
      "price": 0
    },
    "vermselected": true,
    "vermdisabled": false,
    "vermsb": "SB300",
    "vermwohnungen": [{
      "beschreibung": "Wohneinheit 1",
      "strasse": "Leipziger Strasse",
      "hausnummer": "65",
      "ort": "Minden Dankersen",
      "plz": "32423",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "1111",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 2",
      "strasse": "Ziegelstr.",
      "hausnummer": "93",
      "ort": "Jandelsbrunn",
      "plz": "94118",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "2222",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 3",
      "strasse": "Hedemannstasse",
      "hausnummer": "27",
      "ort": "Bermatingen",
      "plz": "88697",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "3333",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 4",
      "strasse": "Schoenebergerstrasse",
      "hausnummer": "80",
      "ort": "Meerane",
      "plz": "08384",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "4444",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 5",
      "strasse": "Mühlenstrasse",
      "hausnummer": "63",
      "ort": "Würzburg",
      "plz": "97016",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "5555",
      "price": 154.32,
      "hasError": false
    }
    ],
    "vermvalid": true,
    "productLine": "EXP",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "H",
      "titel": "Dr.",
      "firstname": "Max",
      "lastname": "Mustermann",
      "strasse": "Ollenhauer Str.",
      "hausnummer": "3",
      "adresszusatz": "App. 1",
      "plz": "70195",
      "ort": "Stuttgart Botnang",
      "geburt": "01.01.1952",
      "beruf": "Gartenbautechniker/in Friedhofsgärtnerei",
      "email": "max.mustermann@yahoo.com",
      "mobil": "0711 57 71 10",
      "telefon": "0711 57 71 10",
      "staat": "Deutschland",
      "hasvorversicherung": "J",
      "anzahlvorversicherungen": 3,
      "anzahlbesuche": "9999",
      "anzahlschaeden": "17",
      "leistungshoeheRecht": "500000",
      "leistungshoeheAnwalt": "999999999",
      "streitAktuell": "J",
      "anwaltGeplant": "J",
      "vorversicherung": [{
        "zum": "01.01.2017",
        "vorversicherer": "Matrix Insurance",
        "vscheinnr": "1234",
        "von": "VN"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "ARAG",
        "vscheinnr": "2345",
        "von": "VR"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "Allianz",
        "vscheinnr": "3456",
        "von": "VR"
      }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": ["email", "telefon", "mobil", "staat", "plz", "ort", "strasse"],
      "anrede": "F",
      "titel": "Prof.",
      "firstname": "Maria",
      "lastname": "Mustermann",
      "geburt": "01.01.1955",
      "beruf": "Juniorprofessor/in",
      "hasvorversicherung": "J",
      "anzahlvorversicherungen": 3,
      "anzahlbesuche": "1",
      "anzahlschaeden": "1",
      "leistungshoeheRecht": "1000",
      "leistungshoeheAnwalt": "2000",
      "streitAktuell": "J",
      "anwaltGeplant": "J",
      "vorversicherung": [{
        "zum": "01.01.2017",
        "vorversicherer": "Matrix",
        "vscheinnr": "11",
        "von": "VR"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "ARAX",
        "vscheinnr": "22",
        "von": "VN"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "Allianz",
        "vscheinnr": "33",
        "von": "VN"
      }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": ["beruf", "email", "telefon", "mobil", "staat"],
      "anrede": "H",
      "titel": "El cheffe",
      "firstname": "Philipp",
      "lastname": "Flasterstein",
      "strasse": "Knesebeckstraße",
      "plz": "58540",
      "ort": "Meinerzhagen",
      "geburt": "11.11.1999",
      "adresszusatz": "oben",
      "hausnummer": "35"
    },
    "iban": "DE65450441676243460939",
    "bic": "",
    "inhabertyp": "AK",
    "rechnungszahler": "N",
    "zahlweise": "4",
    "versicherungsbeginn": "11.11.2018",
    "hauptfaelligkeit": "02.02.",
    "aula": "N",
    "invitatio": "J",
    "werbezwecke": "J",
    "anmerkungen": "Wolfgang ist Spitze!",
    "files": [{
      "fileObject": true,
      "size": 153074,
      "name": "more_colorful_fractals_by_futureintern-d2ylv1b.jpg",
      "type": "image/jpeg",
      "active": false,
      "error": "network",
      "success": false,
      "putAction": "__vue_devtool_undefined__",
      "postAction": "http://localhost:54555/api/uploadtodb",
      "timeout": 0,
      "file": "[object File]",
      "el": "[object HTMLInputElement]",
      "response": {},
      "progress": "0.00",
      "speed": 0,
      "data": {},
      "headers": {},
      "id": "7k8fl5nnk4o",
      "xhr": "[object XMLHttpRequest]"
    }
    ],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [],
    "producterror": false,
    "guid": "ac24a98d-5970-43a0-8997-22ed1a0e2b0b",
    "angebotsnummer": "0181041948",
    "art": "Kurzangebot",
    "pdfpfad": "/maklerportalneu/api/download/4",
    "erstellt": "15.09.2018"
  },
  {
    "user": {
      "name": "tkruegl",
      "vmnr": "99999"
    },
    "submitTime": "13.9.2016, 14:55:05",
    "angebotsnummer": "3107737723",
    "guid": "d63f2368-bf1c-4add-8133-4744500e7e39",
    "pdfpfad": "/maklerportalneu/api/download/124",
    "civilServant": false,
    "categories": ["P"],
    "family": "EPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Familie",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "PRE-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": false,
    "ssrdisabled": true,
    "ssrsb": "SB150",
    "cyberselected": false,
    "cyberdisabled": true,
    "cybersb": "SB150",
    "zwselected": false,
    "zwdisabled": true,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "",
      "hausnummer": "",
      "ort": "",
      "plz": "",
      "bruttojahresmiete": "",
      "land": "",
      "sb": "",
      "price": 0
    },
    "vermselected": false,
    "vermdisabled": true,
    "vermsb": "SB300",
    "vermwohnungen": [{
      "beschreibung": "Wohneinheit 1",
      "strasse": "",
      "hausnummer": "",
      "ort": "",
      "plz": "",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": null,
      "price": 0,
      "hasError": true
    }
    ],
    "vermvalid": false,
    "productLine": "PRE",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "F",
      "titel": "",
      "firstname": "asd",
      "lastname": "asd",
      "strasse": "sdf",
      "hausnummer": "5",
      "adresszusatz": "",
      "plz": "55555",
      "ort": "sdf",
      "geburt": "05.05.1955",
      "beruf": "Abschleppwagenfahrer/in",
      "email": "a@b.de",
      "mobil": "",
      "telefon": "+49",
      "staat": "Deutschland",
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [{
        "zum": null,
        "vorversicherer": "",
        "vscheinnr": "",
        "von": "VN"
      }, {
        "zum": null,
        "vorversicherer": "",
        "vscheinnr": "",
        "von": "VN"
      }, {
        "zum": null,
        "vorversicherer": "",
        "vscheinnr": "",
        "von": "VN"
      }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": ["email", "telefon", "mobil", "staat", "plz", "ort", "strasse"],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "geburt": "",
      "beruf": null,
      "hasvorversicherung": "N",
      "anzahlvorversicherungen": 1,
      "anzahlbesuche": 0,
      "anzahlschaeden": 0,
      "leistungshoeheRecht": null,
      "leistungshoeheAnwalt": null,
      "streitAktuell": "N",
      "anwaltGeplant": "N",
      "vorversicherung": [{
        "zum": null,
        "vorversicherer": "",
        "vscheinnr": "",
        "von": "VN"
      }, {
        "zum": null,
        "vorversicherer": "",
        "vscheinnr": "",
        "von": "VN"
      }, {
        "zum": null,
        "vorversicherer": "",
        "vscheinnr": "",
        "von": "VN"
      }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": ["beruf", "email", "telefon", "mobil", "staat"],
      "anrede": "F",
      "titel": "",
      "firstname": "",
      "lastname": "",
      "strasse": "",
      "plz": "",
      "ort": "",
      "geburt": ""
    },
    "iban": "",
    "bic": "",
    "inhabertyp": "VN",
    "rechnungszahler": "J",
    "zahlweise": "1",
    "versicherungsbeginn": "11.11.2018",
    "hauptfaelligkeit": null,
    "aula": "N",
    "invitatio": "N",
    "werbezwecke": "J",
    "anmerkungen": "",
    "files": [],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [],
    "producterror": false,
    "art": "Angebot",
    "erstellt": "13.09.2018 14:55:10"
  },
  {
    "angebotsnummer": "6012011069",
    "produkt": "L7002",
    "art": "Kurzangebot",
    "name": " ",
    "erstellt": "2016-01-12T18:08:50",
    "vn": { "firstname": "", "lastname": "" },
    "leistungsart": "AGROMEX",
    "editpath": "/maklerportal/abschluss.aspx?P=S&DR=2016-01-12-18-08-50",
    "pdfpfad": "/maklerportal/getangpdf.aspx?dr=2016-01-12-18-08-50&gw=0"
  },
  {
    "angebotsnummer": "8040010379",
    "produkt": "ÄRZTE",
    "art": "Angebot",
    "name": "Gemeinschaftspraxis Testinger ",
    "erstellt": "2018-02-09T10:11:45",
    "leistungsart": "KOMedEX",
    "editpath": "/maklerportal/komedex.aspx?DR=2018-02-09-10-11-45",
    "pdfpfad": "/maklerportal/getangpdf.aspx?dr=2018-02-09-10-11-45&gw=1"
  },
  {
    "user": {
      "name": "gh1",
      "vmnr": "99998"
    },
    "step1locked": true,
    "submitTime": "6.9.2018, 10:40:57",
    "civilServant": true,
    "categories": ["P", "V", "B"],
    "family": "MPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Familie",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "EXP-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": true,
    "ssrdisabled": false,
    "ssrsb": "SB300",
    "cyberselected": true,
    "cyberdisabled": false,
    "cybersb": "SB150",
    "zwselected": true,
    "zwdisabled": false,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "Hallesches Ufer",
      "hausnummer": "83",
      "ort": "Perl",
      "plz": "66706",
      "bruttojahresmiete": "",
      "land": "Deutschland",
      "sb": "",
      "price": 0
    },
    "vermselected": true,
    "vermdisabled": false,
    "vermsb": "SB300",
    "vermwohnungen": [{
      "beschreibung": "Wohneinheit 1",
      "strasse": "Leipziger Strasse",
      "hausnummer": "65",
      "ort": "Minden Dankersen",
      "plz": "32423",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "1111",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 2",
      "strasse": "Ziegelstr.",
      "hausnummer": "93",
      "ort": "Jandelsbrunn",
      "plz": "94118",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "2222",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 3",
      "strasse": "Hedemannstasse",
      "hausnummer": "27",
      "ort": "Bermatingen",
      "plz": "88697",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "3333",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 4",
      "strasse": "Schoenebergerstrasse",
      "hausnummer": "80",
      "ort": "Meerane",
      "plz": "08384",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "4444",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 5",
      "strasse": "Mühlenstrasse",
      "hausnummer": "63",
      "ort": "Würzburg",
      "plz": "97016",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "5555",
      "price": 154.32,
      "hasError": false
    }
    ],
    "vermvalid": true,
    "productLine": "EXP",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "H",
      "titel": "Dr.",
      "firstname": "Max",
      "lastname": "Mustermann",
      "strasse": "Ollenhauer Str.",
      "hausnummer": "3",
      "adresszusatz": "App. 1",
      "plz": "70195",
      "ort": "Stuttgart Botnang",
      "geburt": "01.01.1952",
      "beruf": "Gartenbautechniker/in Friedhofsgärtnerei",
      "email": "max.mustermann@yahoo.com",
      "mobil": "0711 57 71 10",
      "telefon": "0711 57 71 10",
      "staat": "Deutschland",
      "hasvorversicherung": "J",
      "anzahlvorversicherungen": 3,
      "anzahlbesuche": "9999",
      "anzahlschaeden": "17",
      "leistungshoeheRecht": "500000",
      "leistungshoeheAnwalt": "999999999",
      "streitAktuell": "J",
      "anwaltGeplant": "J",
      "vorversicherung": [{
        "zum": "01.01.2017",
        "vorversicherer": "Matrix Insurance",
        "vscheinnr": "1234",
        "von": "VN"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "ARAG",
        "vscheinnr": "2345",
        "von": "VR"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "Allianz",
        "vscheinnr": "3456",
        "von": "VR"
      }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": ["email", "telefon", "mobil", "staat", "plz", "ort", "strasse"],
      "anrede": "F",
      "titel": "Prof.",
      "firstname": "Maria",
      "lastname": "Mustermann",
      "geburt": "01.01.1955",
      "beruf": "Juniorprofessor/in",
      "hasvorversicherung": "J",
      "anzahlvorversicherungen": 3,
      "anzahlbesuche": "1",
      "anzahlschaeden": "1",
      "leistungshoeheRecht": "1000",
      "leistungshoeheAnwalt": "2000",
      "streitAktuell": "J",
      "anwaltGeplant": "J",
      "vorversicherung": [{
        "zum": "01.01.2017",
        "vorversicherer": "Matrix",
        "vscheinnr": "11",
        "von": "VR"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "ARAX",
        "vscheinnr": "22",
        "von": "VN"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "Allianz",
        "vscheinnr": "33",
        "von": "VN"
      }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": ["beruf", "email", "telefon", "mobil", "staat"],
      "anrede": "H",
      "titel": "El cheffe",
      "firstname": "Philipp",
      "lastname": "Flasterstein",
      "strasse": "Knesebeckstraße",
      "plz": "58540",
      "ort": "Meinerzhagen",
      "geburt": "11.11.1999",
      "adresszusatz": "oben",
      "hausnummer": "35"
    },
    "iban": "DE65450441676243460939",
    "bic": "",
    "inhabertyp": "AK",
    "rechnungszahler": "N",
    "zahlweise": "4",
    "versicherungsbeginn": "11.11.2018",
    "hauptfaelligkeit": "02.02.",
    "aula": "N",
    "invitatio": "J",
    "werbezwecke": "J",
    "anmerkungen": "Wolfgang ist Spitze!",
    "files": [{
      "fileObject": true,
      "size": 153074,
      "name": "more_colorful_fractals_by_futureintern-d2ylv1b.jpg",
      "type": "image/jpeg",
      "active": false,
      "error": "network",
      "success": false,
      "putAction": "__vue_devtool_undefined__",
      "postAction": "http://localhost:54555/api/uploadtodb",
      "timeout": 0,
      "file": "[object File]",
      "el": "[object HTMLInputElement]",
      "response": {},
      "progress": "0.00",
      "speed": 0,
      "data": {},
      "headers": {},
      "id": "7k8fl5nnk4o",
      "xhr": "[object XMLHttpRequest]"
    }
    ],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [],
    "producterror": false,
    "guid": "ac24a98d-5970-43a0-8997-22ed1a0e2b0b",
    "angebotsnummer": "0181041948",
    "art": "Kurzangebot",
    "pdfpfad": "/maklerportalneu/api/download/4",
    "erstellt": "15.09.2018"
  },
  {
    "user": {
      "name": "gh1",
      "vmnr": "99998"
    },
    "step1locked": true,
    "submitTime": "6.9.2018, 10:40:57",
    "civilServant": true,
    "categories": ["P", "W"],
    "family": "MPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Familie",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "EXP-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": true,
    "ssrdisabled": false,
    "ssrsb": "SB300",
    "cyberselected": true,
    "cyberdisabled": false,
    "cybersb": "SB150",
    "zwselected": true,
    "zwdisabled": false,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "Hallesches Ufer",
      "hausnummer": "83",
      "ort": "Perl",
      "plz": "66706",
      "bruttojahresmiete": "",
      "land": "Deutschland",
      "sb": "",
      "price": 0
    },
    "vermselected": true,
    "vermdisabled": false,
    "vermsb": "SB300",
    "vermwohnungen": [{
      "beschreibung": "Wohneinheit 1",
      "strasse": "Leipziger Strasse",
      "hausnummer": "65",
      "ort": "Minden Dankersen",
      "plz": "32423",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "1111",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 2",
      "strasse": "Ziegelstr.",
      "hausnummer": "93",
      "ort": "Jandelsbrunn",
      "plz": "94118",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "2222",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 3",
      "strasse": "Hedemannstasse",
      "hausnummer": "27",
      "ort": "Bermatingen",
      "plz": "88697",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "3333",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 4",
      "strasse": "Schoenebergerstrasse",
      "hausnummer": "80",
      "ort": "Meerane",
      "plz": "08384",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "4444",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 5",
      "strasse": "Mühlenstrasse",
      "hausnummer": "63",
      "ort": "Würzburg",
      "plz": "97016",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "5555",
      "price": 154.32,
      "hasError": false
    }
    ],
    "vermvalid": true,
    "productLine": "EXP",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "H",
      "titel": "Dr.",
      "firstname": "Max",
      "lastname": "Mustermann",
      "strasse": "Ollenhauer Str.",
      "hausnummer": "3",
      "adresszusatz": "App. 1",
      "plz": "70195",
      "ort": "Stuttgart Botnang",
      "geburt": "01.01.1952",
      "beruf": "Gartenbautechniker/in Friedhofsgärtnerei",
      "email": "max.mustermann@yahoo.com",
      "mobil": "0711 57 71 10",
      "telefon": "0711 57 71 10",
      "staat": "Deutschland",
      "hasvorversicherung": "J",
      "anzahlvorversicherungen": 3,
      "anzahlbesuche": "9999",
      "anzahlschaeden": "17",
      "leistungshoeheRecht": "500000",
      "leistungshoeheAnwalt": "999999999",
      "streitAktuell": "J",
      "anwaltGeplant": "J",
      "vorversicherung": [{
        "zum": "01.01.2017",
        "vorversicherer": "Matrix Insurance",
        "vscheinnr": "1234",
        "von": "VN"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "ARAG",
        "vscheinnr": "2345",
        "von": "VR"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "Allianz",
        "vscheinnr": "3456",
        "von": "VR"
      }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": ["email", "telefon", "mobil", "staat", "plz", "ort", "strasse"],
      "anrede": "F",
      "titel": "Prof.",
      "firstname": "Maria",
      "lastname": "Mustermann",
      "geburt": "01.01.1955",
      "beruf": "Juniorprofessor/in",
      "hasvorversicherung": "J",
      "anzahlvorversicherungen": 3,
      "anzahlbesuche": "1",
      "anzahlschaeden": "1",
      "leistungshoeheRecht": "1000",
      "leistungshoeheAnwalt": "2000",
      "streitAktuell": "J",
      "anwaltGeplant": "J",
      "vorversicherung": [{
        "zum": "01.01.2017",
        "vorversicherer": "Matrix",
        "vscheinnr": "11",
        "von": "VR"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "ARAX",
        "vscheinnr": "22",
        "von": "VN"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "Allianz",
        "vscheinnr": "33",
        "von": "VN"
      }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": ["beruf", "email", "telefon", "mobil", "staat"],
      "anrede": "H",
      "titel": "El cheffe",
      "firstname": "Philipp",
      "lastname": "Flasterstein",
      "strasse": "Knesebeckstraße",
      "plz": "58540",
      "ort": "Meinerzhagen",
      "geburt": "11.11.1999",
      "adresszusatz": "oben",
      "hausnummer": "35"
    },
    "iban": "DE65450441676243460939",
    "bic": "",
    "inhabertyp": "AK",
    "rechnungszahler": "N",
    "zahlweise": "4",
    "versicherungsbeginn": "11.11.2018",
    "hauptfaelligkeit": "02.02.",
    "aula": "N",
    "invitatio": "J",
    "werbezwecke": "J",
    "anmerkungen": "Wolfgang ist Spitze!",
    "files": [{
      "fileObject": true,
      "size": 153074,
      "name": "more_colorful_fractals_by_futureintern-d2ylv1b.jpg",
      "type": "image/jpeg",
      "active": false,
      "error": "network",
      "success": false,
      "putAction": "__vue_devtool_undefined__",
      "postAction": "http://localhost:54555/api/uploadtodb",
      "timeout": 0,
      "file": "[object File]",
      "el": "[object HTMLInputElement]",
      "response": {},
      "progress": "0.00",
      "speed": 0,
      "data": {},
      "headers": {},
      "id": "7k8fl5nnk4o",
      "xhr": "[object XMLHttpRequest]"
    }
    ],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [],
    "producterror": false,
    "guid": "ac24a98d-5970-43a0-8997-22ed1a0e2b0b",
    "angebotsnummer": "0181041948",
    "art": "Kurzangebot",
    "pdfpfad": "/maklerportalneu/api/download/4",
    "erstellt": "15.09.2018"
  },
  {
    "user": {
      "name": "gh1",
      "vmnr": "99998"
    },
    "step1locked": true,
    "submitTime": "6.9.2018, 10:40:57",
    "civilServant": true,
    "categories": ["V"],
    "family": "MPH",
    "contractlength": "1",
    "sus": false,
    "trafficType": "Familie",
    "car1license": "",
    "car2license": "",
    "car3license": "",
    "car4license": "",
    "car5license": "",
    "showkfz": 0,
    "matrixSelection": "EXP-0",
    "price": null,
    "productText": "",
    "retention": 0,
    "ssrselected": true,
    "ssrdisabled": false,
    "ssrsb": "SB300",
    "cyberselected": true,
    "cyberdisabled": false,
    "cybersb": "SB150",
    "zwselected": true,
    "zwdisabled": false,
    "zweitwohnung": {
      "beschreibung": "",
      "strasse": "Hallesches Ufer",
      "hausnummer": "83",
      "ort": "Perl",
      "plz": "66706",
      "bruttojahresmiete": "",
      "land": "Deutschland",
      "sb": "",
      "price": 0
    },
    "vermselected": true,
    "vermdisabled": false,
    "vermsb": "SB300",
    "vermwohnungen": [{
      "beschreibung": "Wohneinheit 1",
      "strasse": "Leipziger Strasse",
      "hausnummer": "65",
      "ort": "Minden Dankersen",
      "plz": "32423",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "1111",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 2",
      "strasse": "Ziegelstr.",
      "hausnummer": "93",
      "ort": "Jandelsbrunn",
      "plz": "94118",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "2222",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 3",
      "strasse": "Hedemannstasse",
      "hausnummer": "27",
      "ort": "Bermatingen",
      "plz": "88697",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "3333",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 4",
      "strasse": "Schoenebergerstrasse",
      "hausnummer": "80",
      "ort": "Meerane",
      "plz": "08384",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "4444",
      "price": 154.32,
      "hasError": false
    }, {
      "beschreibung": "Wohneinheit 5",
      "strasse": "Mühlenstrasse",
      "hausnummer": "63",
      "ort": "Würzburg",
      "plz": "97016",
      "land": "Deutschland",
      "sb": "SB300",
      "bruttojahresmiete": "5555",
      "price": 154.32,
      "hasError": false
    }
    ],
    "vermvalid": true,
    "productLine": "EXP",
    "sb": "SB0",
    "tmpMatrixState": {
      "family": "MPH",
      "contractlength": "1",
      "categories": [],
      "sb": "",
      "productLine": "",
      "sus": false,
      "price": 0
    },
    "vn": {
      "rolle": "Antragsteller",
      "anrede": "H",
      "titel": "Dr.",
      "firstname": "Max",
      "lastname": "Mustermann",
      "strasse": "Ollenhauer Str.",
      "hausnummer": "3",
      "adresszusatz": "App. 1",
      "plz": "70195",
      "ort": "Stuttgart Botnang",
      "geburt": "01.01.1952",
      "beruf": "Gartenbautechniker/in Friedhofsgärtnerei",
      "email": "max.mustermann@yahoo.com",
      "mobil": "0711 57 71 10",
      "telefon": "0711 57 71 10",
      "staat": "Deutschland",
      "hasvorversicherung": "J",
      "anzahlvorversicherungen": 3,
      "anzahlbesuche": "9999",
      "anzahlschaeden": "17",
      "leistungshoeheRecht": "500000",
      "leistungshoeheAnwalt": "999999999",
      "streitAktuell": "J",
      "anwaltGeplant": "J",
      "vorversicherung": [{
        "zum": "01.01.2017",
        "vorversicherer": "Matrix Insurance",
        "vscheinnr": "1234",
        "von": "VN"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "ARAG",
        "vscheinnr": "2345",
        "von": "VR"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "Allianz",
        "vscheinnr": "3456",
        "von": "VR"
      }
      ]
    },
    "mvp": {
      "rolle": "Mitzuversichernder Lebenspartner",
      "unused": ["email", "telefon", "mobil", "staat", "plz", "ort", "strasse"],
      "anrede": "F",
      "titel": "Prof.",
      "firstname": "Maria",
      "lastname": "Mustermann",
      "geburt": "01.01.1955",
      "beruf": "Juniorprofessor/in",
      "hasvorversicherung": "J",
      "anzahlvorversicherungen": 3,
      "anzahlbesuche": "1",
      "anzahlschaeden": "1",
      "leistungshoeheRecht": "1000",
      "leistungshoeheAnwalt": "2000",
      "streitAktuell": "J",
      "anwaltGeplant": "J",
      "vorversicherung": [{
        "zum": "01.01.2017",
        "vorversicherer": "Matrix",
        "vscheinnr": "11",
        "von": "VR"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "ARAX",
        "vscheinnr": "22",
        "von": "VN"
      }, {
        "zum": "01.01.2017",
        "vorversicherer": "Allianz",
        "vscheinnr": "33",
        "von": "VN"
      }
      ]
    },
    "kontoinhaber": {
      "rolle": "Kontoinhaber",
      "unused": ["beruf", "email", "telefon", "mobil", "staat"],
      "anrede": "H",
      "titel": "El cheffe",
      "firstname": "Philipp",
      "lastname": "Flasterstein",
      "strasse": "Knesebeckstraße",
      "plz": "58540",
      "ort": "Meinerzhagen",
      "geburt": "11.11.1999",
      "adresszusatz": "oben",
      "hausnummer": "35"
    },
    "iban": "DE65450441676243460939",
    "bic": "",
    "inhabertyp": "AK",
    "rechnungszahler": "N",
    "zahlweise": "4",
    "versicherungsbeginn": "11.11.2018",
    "hauptfaelligkeit": "02.02.",
    "aula": "N",
    "invitatio": "J",
    "werbezwecke": "J",
    "anmerkungen": "Wolfgang ist Spitze!",
    "files": [{
      "fileObject": true,
      "size": 153074,
      "name": "more_colorful_fractals_by_futureintern-d2ylv1b.jpg",
      "type": "image/jpeg",
      "active": false,
      "error": "network",
      "success": false,
      "putAction": "__vue_devtool_undefined__",
      "postAction": "http://localhost:54555/api/uploadtodb",
      "timeout": 0,
      "file": "[object File]",
      "el": "[object HTMLInputElement]",
      "response": {},
      "progress": "0.00",
      "speed": 0,
      "data": {},
      "headers": {},
      "id": "7k8fl5nnk4o",
      "xhr": "[object XMLHttpRequest]"
    }
    ],
    "fileIds": [],
    "displayerrors": false,
    "errormessages": [],
    "producterror": false,
    "guid": "ac24a98d-5970-43a0-8997-22ed1a0e2b0b",
    "angebotsnummer": "0181041948",
    "art": "Kurzangebot",
    "pdfpfad": "/maklerportalneu/api/download/4",
    "erstellt": "15.09.2018"
  },
  {
    "deckungen":[
      {
        "ref":"vn1",
        "produkt":"SPEZ-PBV+MIET",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":1085,
          "z1":1030.75,
          "z2":530.84,
          "z4":270.57,
          "z12":91.05
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"gf3",
        "produkt":"SPEZ-PRIV",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":0,
          "z1":0,
          "z2":0,
          "z4":0,
          "z12":0
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"vn1",
        "produkt":"SPEZ-T",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":147.54,
          "z1":140.16,
          "z2":72.18,
          "z4":36.79,
          "z12":12.38
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"vn1",
        "produkt":"SPEZ-SSRG",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":232.2,
          "z1":220.59,
          "z2":113.61,
          "z4":57.91,
          "z12":19.48
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"gf3",
        "produkt":"SPEZ-PRIVSSR",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":0,
          "z1":0,
          "z2":0,
          "z4":0,
          "z12":0
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"vn1",
        "produkt":"MIETZ",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":1124,
          "z1":1067.8,
          "z2":549.92,
          "z4":280.3,
          "z12":94.32
        },
        "immoRef":"immo4",
        "wohnRef":null
      },
      {
        "ref":"gf3",
        "produkt":"SPEZ-PRIVCYBER",
        "sb":{
          "gewerbe":"500",
          "privat":"150"
        },
        "praemie":{
          "base":73.75,
          "z1":70.06,
          "z2":36.08,
          "z4":18.4,
          "z12":6.19
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"gf3",
        "produkt":"SPEZ-PRIVPRESTIGE",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":38,
          "z1":36.1,
          "z2":18.59,
          "z4":9.48,
          "z12":3.19
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"gf3",
        "produkt":"SPEZ-PRIVVM",
        "sb":{
          "gewerbe":null,
          "privat":"300"
        },
        "praemie":{
          "base":154.32,
          "z1":146.6,
          "z2":75.5,
          "z4":38.48,
          "z12":12.95
        },
        "immoRef":null,
        "wohnRef":"wohn5"
      },
      {
        "ref":"gf6",
        "produkt":"SPEZ-PRIV",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":223.41,
          "z1":212.24,
          "z2":109.3,
          "z4":55.71,
          "z12":18.75
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"gf6",
        "produkt":"SPEZ-PRIVCYBER",
        "sb":{
          "gewerbe":"500",
          "privat":"150"
        },
        "praemie":{
          "base":73.75,
          "z1":70.06,
          "z2":36.08,
          "z4":18.4,
          "z12":6.19
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"gf6",
        "produkt":"SPEZ-PRIVSSR",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":33.35,
          "z1":31.68,
          "z2":16.32,
          "z4":8.32,
          "z12":2.8
        },
        "immoRef":null,
        "wohnRef":null
      },
      {
        "ref":"gf6",
        "produkt":"SPEZ-PRIVZW",
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "praemie":{
          "base":43.22,
          "z1":41.06,
          "z2":21.15,
          "z4":10.78,
          "z12":3.63
        },
        "immoRef":null,
        "wohnRef":"zw13"
      },
      {
        "ref":"gf6",
        "produkt":"SPEZ-PRIVVM",
        "sb":{
          "gewerbe":null,
          "privat":"300"
        },
        "praemie":{
          "base":154.32,
          "z1":146.6,
          "z2":75.5,
          "z4":38.48,
          "z12":12.95
        },
        "immoRef":null,
        "wohnRef":"wohn7"
      }
    ],
    "personen":[
      {
        "key":"vn1",
        "firma":true,
        "name":"Kompex lang",
        "rechtsform":"GmbH & Co. KG",
        "branche":{
          "code":"0004",
          "name":"Apotheken"
        },
        "handelsregister":"Handelsregister Abteilung A",
        "hrnummer":"12345",
        "strasse":"Hauptsitz",
        "hausnummer":"1",
        "adresszusatz":null,
        "plz":"50968",
        "ort":"Köln",
        "staat":"Deutschland",
        "email":"test@mail.com",
        "telefon":"",
        "anzahlFilialen":"2"
      },
      {
        "key":"mvu2",
        "firma":true,
        "name":"MVU1",
        "rechtsform":"AG",
        "branche":{
          "code":"0006",
          "name":"Architekturbüro"
        },
        "handelsregister":"Handelsregister Abteilung B",
        "hrnummer":"XYZWER",
        "strasse":"Standort",
        "hausnummer":"2",
        "adresszusatz":null,
        "plz":"94032",
        "ort":"Passau",
        "staat":"Deutschland",
        "email":null,
        "telefon":"",
        "anzahlFilialen":null
      },
      {
        "key":"gf3",
        "firma":false,
        "anrede":"H",
        "titel":null,
        "firstname":"GF",
        "lastname":"Eins",
        "strasse":"Allee",
        "hausnummer":"1",
        "adresszusatz":null,
        "plz":"94032",
        "ort":"Passau",
        "beruf":null,
        "email":null,
        "mobil":null,
        "telefon":"",
        "staat":"Deutschland"
      },
      {
        "key":"gf6",
        "firma":false,
        "anrede":"kA",
        "titel":null,
        "firstname":"GF",
        "lastname":"Zwei",
        "strasse":"Seeweg",
        "hausnummer":"4",
        "adresszusatz":null,
        "plz":"84478",
        "ort":"Waldkraiburg",
        "beruf":null,
        "email":null,
        "mobil":null,
        "telefon":"",
        "staat":"Deutschland"
      },
      {
        "key":"fil8",
        "ref":"vn1",
        "firma":true,
        "name":null,
        "rechtsform":null,
        "branche":{
          "code":null,
          "name":null
        },
        "handelsregister":null,
        "hrnummer":null,
        "strasse":"Vertrieb",
        "hausnummer":"1",
        "adresszusatz":null,
        "plz":"84032",
        "ort":"Altdorf",
        "staat":"Deutschland",
        "email":null,
        "telefon":"",
        "anzahlFilialen":null
      },
      {
        "key":"fil9",
        "ref":"vn1",
        "firma":true,
        "name":null,
        "rechtsform":null,
        "branche":{
          "code":null,
          "name":null
        },
        "handelsregister":null,
        "hrnummer":null,
        "strasse":"Vertrieb",
        "hausnummer":"2",
        "adresszusatz":null,
        "plz":"84032",
        "ort":"Landshut",
        "staat":"Deutschland",
        "email":null,
        "telefon":"",
        "anzahlFilialen":null
      },
      {
        "key":"mvp10",
        "ref":"gf3",
        "firma":false,
        "anrede":"F",
        "titel":null,
        "firstname":"MVP",
        "lastname":"Eins",
        "strasse":null,
        "hausnummer":null,
        "adresszusatz":null,
        "plz":null,
        "ort":null,
        "beruf":"Berufspädagoge/-pädagogin",
        "email":null,
        "mobil":null,
        "telefon":"",
        "staat":"Deutschland"
      },
      {
        "key":"mvp11",
        "ref":"gf6",
        "firma":false,
        "anrede":"H",
        "titel":null,
        "firstname":"MVP",
        "lastname":"Zwei",
        "strasse":null,
        "hausnummer":null,
        "adresszusatz":null,
        "plz":null,
        "ort":null,
        "beruf":"Kraftfahrzeugingenieur/in",
        "email":null,
        "mobil":null,
        "telefon":"",
        "staat":"Deutschland"
      },
      {
        "key":"kto12",
        "firma":false,
        "anrede":"H",
        "titel":null,
        "firstname":"Dagobert",
        "lastname":"Duck",
        "strasse":"Geldspeicher",
        "hausnummer":"1",
        "adresszusatz":null,
        "plz":"34054",
        "ort":"Entenhausen",
        "beruf":null,
        "email":null,
        "mobil":null,
        "telefon":"",
        "staat":"Deutschland"
      }
    ],
    "vertrag":{
      "tarif":"basis",
      "maknummer":"XYZ123",
      "submitTime":"17.03.2020 07:33",
      "guid":null,
      "angebotsnummer":"1964502925",
      "pdfpfad":"/maklerportalneu/api/download/4623",
      "laufzeit":"3",
      "sb":{
        "gewerbe":"500",
        "privat":"300"
      },
      "versicherungsbeginn":"05.05.2020",
      "versicherungsbeginnvergangenheit":false,
      "hauptfaelligkeit":"15.05.",
      "zahlweise":"4",
      "rechnungszahler":"N",
      "aula":"N",
      "werbezwecke":"J",
      "praemie":{
        "base":3382.86,
        "z1":3213.7,
        "z2":1655.07,
        "z4":843.62,
        "z12":283.88
      },
      "produktcode":"G0001"
    },
    "mitarbeiter":{
      "vollzeit":{
        "anzahl":"20",
        "faktor":1
      },
      "teilzeit":{
        "anzahl":"0",
        "faktor":0.5
      },
      "sonstige":{
        "anzahl":"2",
        "faktor":0.25
      },
      "familie":{
        "anzahl":"0",
        "faktor":0
      },
      "inhaber":{
        "anzahl":"2",
        "faktor":0
      }
    },
    "fahrzeuge":{
      "pkw":{
        "flotte":"A",
        "anzahl":0
      },
      "bis4t":{
        "flotte":"A",
        "anzahl":0
      },
      "bis9sitze":{
        "flotte":"A",
        "anzahl":0
      },
      "zugmaschinen":{
        "flotte":"A",
        "anzahl":0
      },
      "sonderfahrzeuge":{
        "flotte":"A",
        "anzahl":0
      },
      "anhaenger":{
        "flotte":"C",
        "anzahl":0
      },
      "ab4t":{
        "flotte":"B",
        "anzahl":0
      },
      "ab9sitze":{
        "flotte":"B",
        "anzahl":0
      },
      "sattelzugmaschinen":{
        "flotte":"B",
        "anzahl":0
      }
    },
    "immobilien":[
      {
        "key":"immo4",
        "art":"VERMIET",
        "bezug":"Vermieter/Verpächter",
        "unit":"Jahresbruttomiete in € (inklusive Nebenkosten)",
        "value":"20000",
        "name":"vermietetes/verpachtetes gew. Objekt Jahresbruttomiete 20.000 €",
        "strasse":"Hauptsitz",
        "hausnummer":"1",
        "plz":"50968",
        "ort":"Köln",
        "staat":"Deutschland",
        "statePath":"gewerbe.immobilien.0"
      }
    ],
    "wohnungen":[
      {
        "key":"wohn5",
        "ref":"gf3",
        "bruttojahresmiete":"8000",
        "strasse":"Allee",
        "hausnummer":"1",
        "plz":"84032",
        "ort":"Altdorf",
        "staat":"Deutschland"
      },
      {
        "key":"wohn7",
        "ref":"gf6",
        "bruttojahresmiete":"7000",
        "strasse":"Seeweg",
        "hausnummer":"2",
        "plz":"84032",
        "ort":"Landshut",
        "staat":"Deutschland"
      }
    ],
    "ferienwohnungen":[
      {
        "key":"zw13",
        "ref":"gf6",
        "bruttojahresmiete":null,
        "strasse":"Rathausplatz",
        "hausnummer":"2",
        "plz":"8001",
        "ort":"Zürich",
        "staat":"Schweiz"
      }
    ],
    "konto":{
      "iban":"AT021420020010147558",
      "bic":"EASYATW1",
      "ref":"kto12"
    },
    "vorversicherungen":[
      {
        "ref":"vn1",
        "anzahlrechtsstreitigkeiten":null,
        "leistungshoeherechtsstreitigkeiten":null,
        "anzahlanwaltsbesuche":null,
        "leistungshoeheanwaltsbesuche":null,
        "streitaktuell":"J",
        "anwaltgeplant":"J",
        "versicherungen":[
          {
            "zum":"01.01.2020",
            "vorversicherer":"ARAG",
            "vscheinnr":"123",
            "von":"VN"
          }
        ]
      },
      {
        "ref":"mvu2",
        "anzahlrechtsstreitigkeiten":null,
        "leistungshoeherechtsstreitigkeiten":null,
        "anzahlanwaltsbesuche":null,
        "leistungshoeheanwaltsbesuche":null,
        "streitaktuell":"N",
        "anwaltgeplant":"N",
        "versicherungen":[
          {
            "zum":"02.02.2020",
            "vorversicherer":"Arag",
            "vscheinnr":"345",
            "von":"VR"
          }
        ]
      },
      {
        "ref":"gf3",
        "anzahlrechtsstreitigkeiten":"1",
        "leistungshoeherechtsstreitigkeiten":"10000",
        "anzahlanwaltsbesuche":"1",
        "leistungshoeheanwaltsbesuche":"4000",
        "streitaktuell":"N",
        "anwaltgeplant":"N",
        "versicherungen":[

        ]
      },
      {
        "ref":"gf6",
        "anzahlrechtsstreitigkeiten":null,
        "leistungshoeherechtsstreitigkeiten":null,
        "anzahlanwaltsbesuche":null,
        "leistungshoeheanwaltsbesuche":null,
        "streitaktuell":"N",
        "anwaltgeplant":"N",
        "versicherungen":[

        ]
      },
      {
        "ref":"fil8",
        "anzahlrechtsstreitigkeiten":null,
        "leistungshoeherechtsstreitigkeiten":null,
        "anzahlanwaltsbesuche":null,
        "leistungshoeheanwaltsbesuche":null,
        "streitaktuell":null,
        "anwaltgeplant":null,
        "versicherungen":[

        ]
      },
      {
        "ref":"fil9",
        "anzahlrechtsstreitigkeiten":null,
        "leistungshoeherechtsstreitigkeiten":null,
        "anzahlanwaltsbesuche":null,
        "leistungshoeheanwaltsbesuche":null,
        "streitaktuell":null,
        "anwaltgeplant":null,
        "versicherungen":[

        ]
      },
      {
        "ref":"mvp10",
        "anzahlrechtsstreitigkeiten":null,
        "leistungshoeherechtsstreitigkeiten":null,
        "anzahlanwaltsbesuche":null,
        "leistungshoeheanwaltsbesuche":null,
        "streitaktuell":"N",
        "anwaltgeplant":"N",
        "versicherungen":[

        ]
      },
      {
        "ref":"mvp11",
        "anzahlrechtsstreitigkeiten":"2",
        "leistungshoeherechtsstreitigkeiten":"500",
        "anzahlanwaltsbesuche":"1",
        "leistungshoeheanwaltsbesuche":"150",
        "streitaktuell":"N",
        "anwaltgeplant":"N",
        "versicherungen":[

        ]
      }
    ],
    "files":[
      {
        "fileObject":true,
        "size":2465,
        "name":"dummy.pdf",
        "type":"application/pdf",
        "active":false,
        "error":"",
        "success":true,
        "postAction":"/maklerportalneu/api/uploadtodb",
        "timeout":0,
        "file":{

        },
        "response":[
          {
            "id":4622,
            "hash":"7C0B759E740F0407BC0B73FA956B682A",
            "filename":"dummy.pdf",
            "creationdate":"2020-03-17T06:33:04.2782299Z",
            "filemetadata":{
              "loginname":"L10106",
              "vmnr":"10106"
            }
          }
        ],
        "progress":"100.00",
        "speed":2654,
        "data":{

        },
        "headers":{

        },
        "id":"1nx8kpkw8d1",
        "xhr":{

        }
      }
    ],
    "fileIds":[
      {
        "fileid":"1nx8kpkw8d1",
        "id":4622,
        "filename":"dummy.pdf"
      }
    ],
    "anmerkungen":"Angehängt ist das Dummy.pdf",
    "ui":{
      "sequentialNumber":14,
      "hasFilialen":true,
      "hasMvUnternehmen":true,
      "hasMvPerson":[
        "gf3",
        "gf6"
      ],
      "hasVorversicherung":{
        "vn1":true,
        "mvu2":true,
        "gf3":false,
        "gf6":false,
        "fil8":null,
        "fil9":null,
        "mvp10":false,
        "mvp11":false
      },
      "hasStreitigkeiten":{
        "vn1":false,
        "mvu2":false,
        "gf3":true,
        "gf6":false,
        "fil8":null,
        "fil9":null,
        "mvp10":false,
        "mvp11":true
      },
      "hasAnwaltsbesuche":{
        "vn1":false,
        "mvu2":false,
        "gf3":true,
        "gf6":false,
        "fil8":null,
        "fil9":null,
        "mvp10":false,
        "mvp11":true
      },
      "isKompex":true,
      "isKompexOhneI":false,
      "produkte":[

      ],
      "hideNotKompex":true,
      "showKompex":true,
      "showKompexOhneImmobilien":false,
      "matrixSelection":{
        "sb":{
          "gewerbe":"500",
          "privat":"300"
        },
        "produkte":[
          "SPEZ-PBV+MIET"
        ]
      },
      "errorSnackbar":{
        "displayerrors":false,
        "timeout":null,
        "closebutton":null,
        "isInfo":null,
        "errormessages":[
          "Ein Online-Angebot kann für diese Produktauswahl nicht erstellt werden. Bitte wenden Sie sich an unseren Maklerservice unter <span class=\"font-weight-medium\" style=\"white-space: nowrap\">(+49) 02 21 / 37 638 - 92</span> oder an <span class=\"font-weight-medium\" style=\"white-space: nowrap\">maklerservice@dmb-rechtsschutz.de</span>. Vielen Dank."
        ]
      },
      "excludeGF":false,
      "accordions":{
        "step1Mvu":{
          "uiOpenPanel":[

          ]
        },
        "step1Immo":{
          "uiOpenPanel":[

          ]
        },
        "step2Immo":{
          "uiOpenPanel":[

          ]
        },
        "step2gf":{
          "uiOpenPanel":[

          ]
        },
        "step3Firma":{
          "uiOpenPanel":[

          ]
        },
        "step3Gfs":{
          "uiOpenPanel":[

          ]
        },
        "step4Vorv":{
          "uiOpenPanel":[

          ]
        },
        "step4Zweit":{
          "uiOpenPanel":[

          ]
        },
        "step4Wohn":{
          "uiOpenPanel":[

          ]
        }
      }
    },
    "selectedIdentity":{
      "metadata":{
        "firstname":"",
        "lastname":""
      },
      "username":"",
      "vmnr":"",
      "tarifname":""
    },
    "user":{
      "metadata":{
        "title":"",
        "firstname":"TEST",
        "lastname":"Ökomakler",
        "company":"",
        "phone":"01721123123",
        "email":"gerhard.heide@web.de",
        "fax":"07 11/7 80 64 64",
        "mobile":"",
        "street":"Gewerbestraße 36a ",
        "postalcode":"70565",
        "city":"Stuttgart",
        "poolvmnr":"",
        "appellation":"",
        "id":394
      },
      "username":"L10106",
      "vmnr":"10106",
      "tarifsatz":"0",
      "maklertyp":"02",
      "logincount":0,
      "rabattvollmacht":null,
      "authorization":null,
      "tarifname":null,
      "datetime":"2020-03-17T06:43:09",
      "subvermittler":null
    },
    "guid":"f9f39a0c-4ec5-4985-8510-e62e532c8202",
    "applicationType":1,
    "angebotsnummer":"1964502925",
    "art":"Angebot",
    "makler":{
      "metadata":{
        "title":"",
        "firstname":"TEST",
        "lastname":"Ökomakler",
        "company":"",
        "phone":"01721123123",
        "email":"gerhard.heide@web.de",
        "fax":"07 11/7 80 64 64",
        "mobile":"",
        "street":"Gewerbestraße 36a ",
        "postalcode":"70565",
        "city":"Stuttgart",
        "poolvmnr":"",
        "appellation":"",
        "id":394
      },
      "username":"L10106",
      "vmnr":"10106",
      "tarifsatz":"0",
      "maklertyp":"02",
      "logincount":0,
      "rabattvollmacht":null,
      "authorization":null,
      "tarifname":null,
      "datetime":"2020-03-17T06:43:09",
      "subvermittler":null
    },
    "pdfpfad":"/maklerportalneu/api/download/4623",
    "submitTime":"17.03.2020 07:33",
    "id":4624,
    "erstellt":"17.03.2020 07:33"
  }

];
